import React, { useEffect } from 'react'
import ro from 'date-fns/locale/ro'
import PropTypes from 'prop-types'
import { Popover, PopoverContent, PopoverTrigger, Input, Portal } from '@chakra-ui/react'
import { DayPicker, useInput } from 'react-day-picker'
import { format, getYear, isValid } from 'date-fns'
// import 'react-day-picker/style.css'
import './DatePicker.css'

const SingleDatePicker = ({
  defaultSelected,
  onChange,
  showYearDropdown,
  placeholder,
  dateFormat,
  inputOptions,
  ...datePickerProps
}) => {
  const options = { ...inputOptions, defaultSelected }
  const input = useInput(options)

  useEffect(() => {
    if (isValid(input.dayPickerProps.selected)) {
      onChange(input.dayPickerProps.selected)
    }
  }, [input.dayPickerProps.selected, onChange])

  return (
    <Popover>
      <PopoverTrigger>
        <Input
          {...input.fieldProps}
          placeholder={format(new Date(), options.format)}
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="fit-content">
          <DayPicker
            fromYear={2020}
            toYear={getYear(new Date()) + 1}
            captionLayout="dropdown"
            {...input.dayPickerProps}
            mode="single"
            defaultSelected={defaultSelected}
            locale={ro}
            {...datePickerProps}
          />
        </PopoverContent>
      </Portal>
    </Popover>
  )
}

SingleDatePicker.propTypes = {
  showYearDropdown: PropTypes.bool
}

SingleDatePicker.defaultProps = {
  showYearDropdown: true,
  inputOptions: {
    format: 'dd.MM.yyyy',
    // Make the selection mandatory.
    required: true
  }
}

export default SingleDatePicker
